<div class="row">
    <div class="col-lg-12">
        <div class="card d-flex align-items-center">
            <div class="card-header">
                <div [innerHTML]="'InterestHeading' | translate"></div>
            </div>
            <img src="../../../assets/images/66233234_9518366.jpg" alt="" class="img-fluid" style="height:300px; width:300px">
        </div>
    </div>
</div>
